import VariationLoader from "./loader";

export const handleVariations = () => {
  const variationsProducts = document.querySelectorAll(".product");

  variationsProducts.forEach((product) => {
    const variations = product.querySelectorAll(".variations > button");
    let isRunning = false;
    variations.forEach((variation) => {
      variation.addEventListener("click", async () => {
        if (isRunning) return;
        if (variation.classList.contains("active")) return;

        let price = product.querySelector(".price");
        let btn = product.querySelector(".btn-add-to-cart");

        product.classList.add("loading");
        price.innerHTML = "";
        const loader = VariationLoader.get(price, "beforeend");

        product.querySelector("[data-variation].active").classList.remove("active");
        variation.classList.add("active");

        isRunning = true;
        const formData = new FormData();
        formData.append("action", "update_variation");
        formData.append("variation_id", variation.dataset.variation);

        let response = await fetch(wtm_global_vars._wtm_ajax, {
          method: "POST",
          body: formData,
        });

        response = await response.json();

        loader.remove();
        product.classList.remove("loading");

        let template = document.createElement("template");
        template.innerHTML = response.price;
        const newPrice = template.content.childNodes[0].innerHTML;
        price.innerHTML = newPrice;

        template.innerHTML = response.link;
        const addToCartButton = product.querySelector(".add_to_cart_button");
        template.content.childNodes[0].getAttributeNames().forEach((attr) => {
          if (attr == "class") return;
          addToCartButton.setAttribute(attr, template.content.childNodes[0].getAttribute(attr));
        });

        isRunning = false;
      });
    });
  });
};
